import * as jose from 'jose';
import keys from '../constants/keys.json';

const JWKS = jose.createLocalJWKSet({ keys });

import { getAuthToken, getUserId } from './localStorage';

export const isTokenValid = async () => {
  try {
    const authToken = getAuthToken();
    const userId = await getUserId();
    const { payload } = await jose.jwtVerify(authToken, JWKS); // Add and audience issuer validation
    return payload && payload.sub === userId;
  }
  catch (ex) {
    return null;
  }
};
